// import axios from 'axios';
// import jwtDecode from 'jwt-decode';

// const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN;
// const CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID;
// const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;
// const LOGOUT_URI = process.env.REACT_APP_LOGOUT_URI;
// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; // This should be 8090 (Gateway)
// const AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL || 'http://localhost:8080'; // OAuth service direct

// class AuthService {
//   redirectToLogin(forceLogin = false) {
//     console.log('AuthService: Redirecting to Cognito login', { forceLogin });
    
//     let authUrl = `https://${COGNITO_DOMAIN}/oauth2/authorize?` +
//       `response_type=code&` +
//       `client_id=${CLIENT_ID}&` +
//       `redirect_uri=${encodeURIComponent(REDIRECT_URI)}&` +
//       `scope=email+openid+profile`;
    
//     if (forceLogin) {
//       authUrl += `&prompt=login`;
//     }
    
//     console.log('Auth URL:', authUrl);
//     window.location.href = authUrl;
//   }

//   redirectToLogout() {
//     console.log('AuthService: Redirecting to Cognito logout');
    
//     // Clear tokens BEFORE redirecting
//     this.clearStoredTokens();
    
//     const logoutUrl = `https://${COGNITO_DOMAIN}/logout?` +
//       `client_id=${CLIENT_ID}&` +
//       `logout_uri=${encodeURIComponent(LOGOUT_URI)}`;
    
//     console.log('Logout URL:', logoutUrl);
//     window.location.href = logoutUrl;
//   }

//   async exchangeCodeForTokens(code) {
//     try {
//       console.log('=== AUTH SERVICE TOKEN EXCHANGE ===');
//       console.log('Code received:', code);
//       console.log('Using AUTH_BASE_URL:', AUTH_BASE_URL);
//       console.log('Using API_BASE_URL:', API_BASE_URL);
      
//       if (!code) {
//         throw new Error('No authorization code provided');
//       }
      
//       if (!REDIRECT_URI) {
//         throw new Error('REDIRECT_URI environment variable not set');
//       }
      
//       const requestData = {
//         code: code,
//         redirect_uri: REDIRECT_URI
//       };
      
//       console.log('Sending request data:', requestData);
      
//       // Try Gateway first (in case it routes auth endpoints)
//       let response;
//       let usedUrl;
      
//       try {
//         usedUrl = `${API_BASE_URL}/api/auth/exchange-code`;
//         console.log('Attempting token exchange via Gateway:', usedUrl);
        
//         response = await axios.post(usedUrl, requestData, {
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           timeout: 10000
//         });
//       } catch (gatewayError) {
//         console.log('Gateway failed, trying direct OAuth service:', gatewayError.message);
        
//         // Fallback to direct OAuth service
//         usedUrl = `${AUTH_BASE_URL}/api/auth/exchange-code`;
//         console.log('Attempting token exchange via OAuth service:', usedUrl);
        
//         response = await axios.post(usedUrl, requestData, {
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           timeout: 10000
//         });
//       }

//       console.log('=== TOKEN EXCHANGE SUCCESS ===');
//       console.log('Used URL:', usedUrl);
//       console.log('Response status:', response.status);
//       console.log('Response data keys:', Object.keys(response.data || {}));
      
//       if (response.data.access_token) {
//         console.log('Access token received (length):', response.data.access_token.length);
//       } else {
//         console.warn('No access_token in response:', response.data);
//       }
      
//       return {
//         accessToken: response.data.access_token,
//         idToken: response.data.id_token,
//         refreshToken: response.data.refresh_token
//       };
//     } catch (error) {
//       console.error('=== TOKEN EXCHANGE FAILED ===');
//       console.error('Error type:', error.constructor.name);
//       console.error('Error message:', error.message);
      
//       if (error.response) {
//         console.error('Response status:', error.response.status);
//         console.error('Response headers:', error.response.headers);
//         console.error('Response data:', error.response.data);
//       } else if (error.request) {
//         console.error('No response received:', error.request);
//       } else {
//         console.error('Request setup error:', error.message);
//       }
      
//       throw error;
//     }
//   }

//   async refreshTokens(refreshToken) {
//     try {
//       console.log('=== AUTH SERVICE TOKEN REFRESH ===');
//       console.log('Refresh token present:', !!refreshToken);
      
//       if (!refreshToken) {
//         throw new Error('No refresh token provided');
//       }
      
//       const requestData = {
//         refresh_token: refreshToken
//       };
      
//       console.log('Sending refresh request...');
      
//       // Try Gateway first (in case it routes auth endpoints)
//       let response;
//       let usedUrl;
      
//       try {
//         usedUrl = `${API_BASE_URL}/api/auth/refresh-token`;
//         console.log('Attempting token refresh via Gateway:', usedUrl);
        
//         response = await axios.post(usedUrl, requestData, {
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           timeout: 10000
//         });
//       } catch (gatewayError) {
//         console.log('Gateway failed, trying direct OAuth service:', gatewayError.message);
        
//         // Fallback to direct OAuth service
//         usedUrl = `${AUTH_BASE_URL}/api/auth/refresh-token`;
//         console.log('Attempting token refresh via OAuth service:', usedUrl);
        
//         response = await axios.post(usedUrl, requestData, {
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           timeout: 10000
//         });
//       }

//       console.log('=== TOKEN REFRESH SUCCESS ===');
//       console.log('Used URL:', usedUrl);
//       console.log('Refresh response status:', response.status);
//       console.log('Refresh response data keys:', Object.keys(response.data || {}));
      
//       return {
//         accessToken: response.data.access_token,
//         idToken: response.data.id_token,
//         refreshToken: refreshToken // Cognito typically doesn't return a new refresh token
//       };
//     } catch (error) {
//       console.error('=== TOKEN REFRESH FAILED ===');
//       console.error('Refresh error:', error.message);
      
//       if (error.response) {
//         console.error('Refresh response status:', error.response.status);
//         console.error('Refresh response data:', error.response.data);
//       }
      
//       throw error;
//     }
//   }

//   async getUserInfo(accessToken) {
//     try {
//       console.log('AuthService: Getting user info from Cognito');
      
//       const response = await axios.get(`https://${COGNITO_DOMAIN}/oauth2/userInfo`, {
//         headers: {
//           Authorization: `Bearer ${accessToken}`
//         },
//         timeout: 10000
//       });
      
//       console.log('User info retrieved:', response.data);
//       return response.data;
//     } catch (error) {
//       console.error('Failed to get user info:', error);
//       throw error;
//     }
//   }

//   storeTokens(tokens) {
//     console.log('AuthService: Storing tokens');
//     console.log('Tokens to store:', {
//       accessToken: !!tokens.accessToken,
//       idToken: !!tokens.idToken,
//       refreshToken: !!tokens.refreshToken
//     });
    
//     if (tokens.accessToken) {
//       localStorage.setItem('accessToken', tokens.accessToken);
//     }
//     if (tokens.idToken) {
//       localStorage.setItem('idToken', tokens.idToken);
//     }
//     if (tokens.refreshToken) {
//       localStorage.setItem('refreshToken', tokens.refreshToken);
//     }
//   }

//   getStoredTokens() {
//     const tokens = {
//       accessToken: localStorage.getItem('accessToken'),
//       idToken: localStorage.getItem('idToken'),
//       refreshToken: localStorage.getItem('refreshToken')
//     };
    
//     console.log('AuthService: Retrieved stored tokens:', {
//       accessToken: tokens.accessToken ? 'Present' : 'Missing',
//       idToken: tokens.idToken ? 'Present' : 'Missing', 
//       refreshToken: tokens.refreshToken ? 'Present' : 'Missing'
//     });
    
//     return tokens;
//   }

//   clearStoredTokens() {
//     console.log('AuthService: Clearing stored tokens');
//     localStorage.removeItem('accessToken');
//     localStorage.removeItem('idToken');
//     localStorage.removeItem('refreshToken');
    
//     // Also clear any other auth-related data
//     localStorage.removeItem('user');
//     localStorage.removeItem('authState');
//   }

//   isTokenValid(token) {
//     try {
//       if (!token) {
//         console.log('AuthService: No token provided for validation');
//         return false;
//       }
      
//       const decoded = jwtDecode(token);
//       const currentTime = Date.now() / 1000;
//       const isValid = decoded.exp > currentTime;
//       const timeUntilExpiry = decoded.exp - currentTime;
      
//       console.log('AuthService: Token validation result:', {
//         isValid: isValid,
//         expiresAt: new Date(decoded.exp * 1000).toISOString(),
//         timeUntilExpirySeconds: Math.round(timeUntilExpiry),
//         timeUntilExpiryMinutes: Math.round(timeUntilExpiry / 60)
//       });
      
//       return isValid;
//     } catch (error) {
//       console.error('AuthService: Token validation failed:', error.message);
//       return false;
//     }
//   }

//   // Complete logout - clears everything and redirects
//   async completeLogout() {
//     console.log('AuthService: Performing complete logout');
    
//     // Clear all stored data
//     this.clearStoredTokens();
    
//     // Redirect to Cognito logout
//     this.redirectToLogout();
//   }

//   // Debug method to check environment variables
//   debugEnvironment() {
//     console.log('=== ENVIRONMENT VARIABLES DEBUG ===');
//     console.log('COGNITO_DOMAIN:', COGNITO_DOMAIN);
//     console.log('CLIENT_ID:', CLIENT_ID);
//     console.log('REDIRECT_URI:', REDIRECT_URI);
//     console.log('LOGOUT_URI:', LOGOUT_URI);
//     console.log('API_BASE_URL (Gateway):', API_BASE_URL);
//     console.log('AUTH_BASE_URL (OAuth):', AUTH_BASE_URL);
    
//     const missing = [];
//     if (!COGNITO_DOMAIN) missing.push('REACT_APP_COGNITO_DOMAIN');
//     if (!CLIENT_ID) missing.push('REACT_APP_COGNITO_CLIENT_ID');
//     if (!REDIRECT_URI) missing.push('REACT_APP_REDIRECT_URI');
//     if (!LOGOUT_URI) missing.push('REACT_APP_LOGOUT_URI');
//     if (!API_BASE_URL) missing.push('REACT_APP_API_BASE_URL');
    
//     if (missing.length > 0) {
//       console.error('Missing environment variables:', missing);
//     } else {
//       console.log('All required environment variables are set');
//     }
    
//     return missing.length === 0;
//   }
// }

// export const authService = new AuthService();

import axios from 'axios';
import jwtDecode from 'jwt-decode';

const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN;
const CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID;
const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;
const LOGOUT_URI = process.env.REACT_APP_LOGOUT_URI;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; // Gateway - should be HTTPS
const AUTH_BASE_URL = process.env.REACT_APP_AUTH_SERVICE_URL;  // OAuth service - should be HTTPS

class AuthService {
  redirectToLogin(forceLogin = false) {
    console.log('AuthService: Redirecting to Cognito login', { forceLogin });
    
    let authUrl = `https://${COGNITO_DOMAIN}/oauth2/authorize?` +
      `response_type=code&` +
      `client_id=${CLIENT_ID}&` +
      `redirect_uri=${encodeURIComponent(REDIRECT_URI)}&` +
      `scope=email+openid+profile`;
    
    if (forceLogin) {
      authUrl += `&prompt=login`;
    }
    
    console.log('Auth URL:', authUrl);
    window.location.href = authUrl;
  }

  redirectToLogout() {
    console.log('AuthService: Redirecting to Cognito logout');
    
    // Clear tokens BEFORE redirecting
    this.clearStoredTokens();
    
    const logoutUrl = `https://${COGNITO_DOMAIN}/logout?` +
      `client_id=${CLIENT_ID}&` +
      `logout_uri=${encodeURIComponent(LOGOUT_URI)}`;
    
    console.log('Logout URL:', logoutUrl);
    window.location.href = logoutUrl;
  }

  async exchangeCodeForTokens(code) {
    try {
      console.log('=== AUTH SERVICE TOKEN EXCHANGE ===');
      console.log('Code received:', code);
      console.log('Using AUTH_BASE_URL:', AUTH_BASE_URL);
      console.log('Using API_BASE_URL:', API_BASE_URL);
      
      if (!code) {
        throw new Error('No authorization code provided');
      }
      
      if (!REDIRECT_URI) {
        throw new Error('REDIRECT_URI environment variable not set');
      }

      // Validate that we have HTTPS URLs for production
      if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable not set');
      }

      if (!AUTH_BASE_URL) {
        throw new Error('REACT_APP_AUTH_BASE_URL environment variable not set');
      }
      
      const requestData = {
        code: code,
        redirect_uri: REDIRECT_URI
      };
      
      console.log('Sending request data:', requestData);
      
      // Try Gateway first (in case it routes auth endpoints)
      let response;
      let usedUrl;
      
      try {
        usedUrl = `${API_BASE_URL}/api/auth/exchange-code`;
        console.log('Attempting token exchange via Gateway:', usedUrl);
        
        response = await axios.post(usedUrl, requestData, {
          headers: {
            'Content-Type': 'application/json'
          },
          timeout: 10000
        });
      } catch (gatewayError) {
        console.log('Gateway failed, trying direct OAuth service:', gatewayError.message);
        
        // Fallback to direct OAuth service - only if AUTH_BASE_URL is available
        usedUrl = `${AUTH_BASE_URL}/api/auth/exchange-code`;
        console.log('Attempting token exchange via OAuth service:', usedUrl);
        
        response = await axios.post(usedUrl, requestData, {
          headers: {
            'Content-Type': 'application/json'
          },
          timeout: 10000
        });
      }

      console.log('=== TOKEN EXCHANGE SUCCESS ===');
      console.log('Used URL:', usedUrl);
      console.log('Response status:', response.status);
      console.log('Response data keys:', Object.keys(response.data || {}));
      
      if (response.data.access_token) {
        console.log('Access token received (length):', response.data.access_token.length);
      } else {
        console.warn('No access_token in response:', response.data);
      }
      
      return {
        accessToken: response.data.access_token,
        idToken: response.data.id_token,
        refreshToken: response.data.refresh_token
      };
    } catch (error) {
      console.error('=== TOKEN EXCHANGE FAILED ===');
      console.error('Error type:', error.constructor.name);
      console.error('Error message:', error.message);
      
      if (error.response) {
        console.error('Response status:', error.response.status);
        console.error('Response headers:', error.response.headers);
        console.error('Response data:', error.response.data);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Request setup error:', error.message);
      }
      
      throw error;
    }
  }

  async refreshTokens(refreshToken) {
    try {
      console.log('=== AUTH SERVICE TOKEN REFRESH ===');
      console.log('Refresh token present:', !!refreshToken);
      
      if (!refreshToken) {
        throw new Error('No refresh token provided');
      }

      if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable not set');
      }

      if (!AUTH_BASE_URL) {
        throw new Error('REACT_APP_AUTH_BASE_URL environment variable not set');
      }
      
      const requestData = {
        refresh_token: refreshToken
      };
      
      console.log('Sending refresh request...');
      
      // Try Gateway first (in case it routes auth endpoints)
      let response;
      let usedUrl;
      
      try {
        usedUrl = `${API_BASE_URL}/api/auth/refresh-token`;
        console.log('Attempting token refresh via Gateway:', usedUrl);
        
        response = await axios.post(usedUrl, requestData, {
          headers: {
            'Content-Type': 'application/json'
          },
          timeout: 10000
        });
      } catch (gatewayError) {
        console.log('Gateway failed, trying direct OAuth service:', gatewayError.message);
        
        // Fallback to direct OAuth service
        usedUrl = `${AUTH_BASE_URL}/api/auth/refresh-token`;
        console.log('Attempting token refresh via OAuth service:', usedUrl);
        
        response = await axios.post(usedUrl, requestData, {
          headers: {
            'Content-Type': 'application/json'
          },
          timeout: 10000
        });
      }

      console.log('=== TOKEN REFRESH SUCCESS ===');
      console.log('Used URL:', usedUrl);
      console.log('Refresh response status:', response.status);
      console.log('Refresh response data keys:', Object.keys(response.data || {}));
      
      return {
        accessToken: response.data.access_token,
        idToken: response.data.id_token,
        refreshToken: refreshToken // Cognito typically doesn't return a new refresh token
      };
    } catch (error) {
      console.error('=== TOKEN REFRESH FAILED ===');
      console.error('Refresh error:', error.message);
      
      if (error.response) {
        console.error('Refresh response status:', error.response.status);
        console.error('Refresh response data:', error.response.data);
      }
      
      throw error;
    }
  }

  // Rest of the methods remain the same...
  async getUserInfo(accessToken) {
    try {
      console.log('AuthService: Getting user info from Cognito');
      
      const response = await axios.get(`https://${COGNITO_DOMAIN}/oauth2/userInfo`, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        timeout: 10000
      });
      
      console.log('User info retrieved:', response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to get user info:', error);
      throw error;
    }
  }

  storeTokens(tokens) {
    console.log('AuthService: Storing tokens');
    console.log('Tokens to store:', {
      accessToken: !!tokens.accessToken,
      idToken: !!tokens.idToken,
      refreshToken: !!tokens.refreshToken
    });
    
    if (tokens.accessToken) {
      localStorage.setItem('accessToken', tokens.accessToken);
    }
    if (tokens.idToken) {
      localStorage.setItem('idToken', tokens.idToken);
    }
    if (tokens.refreshToken) {
      localStorage.setItem('refreshToken', tokens.refreshToken);
    }
  }

  getStoredTokens() {
    const tokens = {
      accessToken: localStorage.getItem('accessToken'),
      idToken: localStorage.getItem('idToken'),
      refreshToken: localStorage.getItem('refreshToken')
    };
    
    console.log('AuthService: Retrieved stored tokens:', {
      accessToken: tokens.accessToken ? 'Present' : 'Missing',
      idToken: tokens.idToken ? 'Present' : 'Missing', 
      refreshToken: tokens.refreshToken ? 'Present' : 'Missing'
    });
    
    return tokens;
  }

  clearStoredTokens() {
    console.log('AuthService: Clearing stored tokens');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('idToken');
    localStorage.removeItem('refreshToken');
    
    // Also clear any other auth-related data
    localStorage.removeItem('user');
    localStorage.removeItem('authState');
  }

  isTokenValid(token) {
    try {
      if (!token) {
        console.log('AuthService: No token provided for validation');
        return false;
      }
      
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      const isValid = decoded.exp > currentTime;
      const timeUntilExpiry = decoded.exp - currentTime;
      
      console.log('AuthService: Token validation result:', {
        isValid: isValid,
        expiresAt: new Date(decoded.exp * 1000).toISOString(),
        timeUntilExpirySeconds: Math.round(timeUntilExpiry),
        timeUntilExpiryMinutes: Math.round(timeUntilExpiry / 60)
      });
      
      return isValid;
    } catch (error) {
      console.error('AuthService: Token validation failed:', error.message);
      return false;
    }
  }

  // Complete logout - clears everything and redirects
  async completeLogout() {
    console.log('AuthService: Performing complete logout');
    
    // Clear all stored data
    this.clearStoredTokens();
    
    // Redirect to Cognito logout
    this.redirectToLogout();
  }

  // Debug method to check environment variables
  debugEnvironment() {
    console.log('=== ENVIRONMENT VARIABLES DEBUG ===');
    console.log('COGNITO_DOMAIN:', COGNITO_DOMAIN);
    console.log('CLIENT_ID:', CLIENT_ID);
    console.log('REDIRECT_URI:', REDIRECT_URI);
    console.log('LOGOUT_URI:', LOGOUT_URI);
    console.log('API_BASE_URL (Gateway):', API_BASE_URL);
    console.log('AUTH_BASE_URL (OAuth):', AUTH_BASE_URL);
    
    const missing = [];
    if (!COGNITO_DOMAIN) missing.push('REACT_APP_COGNITO_DOMAIN');
    if (!CLIENT_ID) missing.push('REACT_APP_COGNITO_CLIENT_ID');
    if (!REDIRECT_URI) missing.push('REACT_APP_REDIRECT_URI');
    if (!LOGOUT_URI) missing.push('REACT_APP_LOGOUT_URI');
    if (!API_BASE_URL) missing.push('REACT_APP_API_BASE_URL');
    if (!AUTH_BASE_URL) missing.push('REACT_APP_AUTH_BASE_URL');
    
    if (missing.length > 0) {
      console.error('Missing environment variables:', missing);
    } else {
      console.log('All required environment variables are set');
    }
    
    return missing.length === 0;
  }
}

export const authService = new AuthService();